var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.461 8.047"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.121 4.426a.389.389 0 010-.563L.684 3.3a.389.389 0 01.563 0l.04.04L3.5 5.714a.194.194 0 00.282 0L9.174.121h.04a.389.389 0 01.563 0l.563.563a.389.389 0 010 .563L3.9 7.927a.389.389 0 01-.563 0L.2 4.547l-.08-.121z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "f4264fed6b9c7f2f5267ffb08b4bb7f3.svg";
export { SvgTick as ReactComponent };